import Vue from 'vue'

Vue.component('BtkyToolbar', () => import('./btky-toolbar/index.vue'))
Vue.component('BtkyCrud', () => import('./btky-crud/index.vue'))
Vue.component('BtkyCustomerSelector', () => import('./btky-selector/index.vue'))
Vue.component('Pagination', () => import('./pagination.vue'))
Vue.component('BtkyFooter', () => import('./Footer/index.vue'))
Vue.component('PurchaseFooter', () => import('./Footer/purchase_index.vue'))
Vue.component('BtkyHeader', () => import('./Header/index.vue'))
Vue.component('CommonTitle', () => import('./CommonTitle/index.vue'))
Vue.component('CollapseQuery', () => import('./CollapseQuery/index.vue'))
Vue.component('CollapseQuery2', () => import('./CollapseQuery2/index.vue'))
Vue.component('CollapseTable', () => import('./CollapseTable/index.vue'))
Vue.component('TableQuery', () => import('./TableQuery/index.vue'))
Vue.component('TableButton', () => import('./TableButton/index.vue'))
Vue.component('TableCommon', () => import('./TableCommon/index.vue'))
Vue.component('TableFilter', () => import('./TableFilter/index.vue'))
Vue.component('TableCustomFilter', () => import('./TableCustomFilter/index.vue'))
Vue.component('QueryParams', () => import('./QueryParams/index.vue'))
Vue.component('ErrorsList', () => import('./ErrorsList/index.vue'))
Vue.component('Affix', () => import('./Affix/index.vue'))
Vue.component('FormButton', () => import('./FormButton/index.vue'))
Vue.component('WlyInput', () => import('./WlyInput/index.vue'))



// WEBPACK FOOTER //
// ./src/components/index.js